import { ContractHook } from '@apeiron/contract'
import { useMktErrorHandling } from '@apeiron/wallet'
import { useCallback } from 'react'

export const useSafeTransferFrom = (): Hook => {
  const { showErrorPopup } = useMktErrorHandling()

  const transfer = useCallback(
    async (params: TransferParam): Promise<boolean> => {
      const { contract, contractParams, onVerify } = params

      try {
        const { from, quantity, to, tokenId } = contractParams

        let result

        if (quantity) {
          result = await contract.send(from, to, tokenId, quantity, '0x0') // for ERC1155 (with quantity)
        } else {
          result = await contract.send(from, to, tokenId) // for ERC721
        }

        if (!result) {
          return false
        }

        await onVerify(tokenId)

        return true
      } catch (e) {
        showErrorPopup(e)

        return false
      }
    },
    [showErrorPopup]
  )

  return { transfer }
}

type ContractParams = {
  from: string
  quantity?: number
  to: string
  tokenId: string
}

type TransferParam = {
  contract: ContractHook<void, void>
  contractParams: ContractParams
  onVerify: (tokenId: string) => Promise<boolean>
}

type Hook = {
  transfer: (params: TransferParam) => Promise<boolean>
}
